import { createContext } from "react"

const Email = createContext()

export default Email
